<template>
  <div>
    <div>
      <el-card>

        <div slot="header">
          <span>管理员列表</span>
        </div>

        <div class="col">

          <el-button type="success" @click='edit("")' size="small" style="width: 80px;">新增</el-button>

          <search :formList="searchList" @search='searchs'></search>

          <el-table :data="list.data" style="width: 100%" v-loading='loading' stripe>
            <el-table-column prop="id" label="ID">
            </el-table-column>
            <el-table-column prop="username" label="用户名">
            </el-table-column>
            <el-table-column label="角色">

              <template slot-scope="scope">
                <span v-if="getObj(scope.row,'role.title')">{{getObj(scope.row,'role.title')}}</span>
                <span v-else>超级管理员</span>
              </template>

            </el-table-column>

            <el-table-column label="状态">
              <template slot-scope="scope">

                <el-tag v-if="scope.row.status==1" type="success" effect="dark" size='mini'>
                  正常
                </el-tag>

                <el-tag v-else-if="scope.row.status==2" type="danger" effect="dark" size='mini'>
                  禁用
                </el-tag>
              </template>
            </el-table-column>


            <el-table-column prop="nick_name" label="昵称">
            </el-table-column>
            <el-table-column prop="created_at" label="创建时间">
            </el-table-column>

            <el-table-column label="上次登录时间">
              <template slot-scope="scope">
                <span v-if="scope.row.last_login_time">{{scope.row.last_login_time}}</span>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="300px">


              <template slot-scope="scope">
                <div class="row-no-full">
                  <el-button type="primary" size="mini" @click='edit(scope.row)'>编辑</el-button>

                  <el-button v-if="scope.row.status==1" type="warning" size="mini" @click='disable(scope.row)'>禁用</el-button>
                  <el-button v-if="scope.row.status==2" type="success" size="mini" @click='open(scope.row)'>解禁</el-button>

                  <el-button type="danger" size="mini" @click='deleteAdmin(scope.row.id)'>删除</el-button>
                </div>
              </template>

            </el-table-column>

          </el-table>

          <el-divider></el-divider>

          <el-pagination layout="prev,pager,next" :current-page='this.$route.query.p | page' :total="list.total"
            @current-change='next' background>
          </el-pagination>

        </div>


      </el-card>
    </div>
  </div>
</template>

<script>
  import Search from '../common/Search.vue'

  export default {
    name: "AdminList",
    data() {
      return {

        list: [],
        loading: false,
        search: {},
        searchList: [{
          type: 'input',
          title: '用户名',
          value: '',
          field: 'username',
          condition: 'like'
        }, ]


      }
    },
    inject: ['reload'],
    methods: {

      getAdminList() {

        this.loading = true;
        this.httpPost({
          url: "/admin/admin/admin_list",
          data: this.$route.query

        }).then((re) => {


          this.list = re.data;

          this.loading = false;
        });
      },
      next(page) {


        this.routerSearch(this, {
          p: page
        });


      },
      edit(obj) {

        this.$router.push({
          path: '/main/admin_edit',
          query: {
            id: obj.id
          }
        });
      },
      deleteAdmin(id) {

        this.messageCommon('警告', '确定删除吗？', 'warning').then(() => {

          this.httpPost({
            url: "/admin/admin/admin_delete/id/" + id,

          }).then((re) => {

            // console.log(re);

            if (re.code == 1) {

              this.getAdminList();
            } else {

              this.$message.error(re.msg);
            }

          });

        });

      },
      searchs(value) {

        console.log(value)

        this.routerSearch(this, {
          search: JSON.stringify(value),
          p: 1
        });

      },

      disable(item) {


        this.msgBoxAjaxWithMessage('提示', '确定禁用吗？', '/admin/admin/disable', {
          id: item.id
        }).then((re) => {

          // if (re.code == 1) {

            this.getAdminList();

          // } else {

          //   this.$notify({
          //     title: '错误',
          //     message: re.msg,
          //     position: 'bottom-right',
          //     type: 'error'
          //   });

          // }

        });


      },
      open(item) {


        this.msgBoxAjax('提示', '确定解禁吗？', '/admin/admin/open', {
          id: item.id
        }).then((re) => {

          this.getAdminList();

        });


      }

    },
    created() {

      this.getAdminList();


    },
    computed: {

    },
    components: {
      Search
    }

  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminList.vue